import {
  type ActionCardData,
  type AssessmentData,
  ElementKind,
  type QuestionData,
  sectionTypes,
} from '@playbooks/action-cards-utils/src'

function getDataFromActionCard(card: ActionCardData) {
  let data: { [key: string]: any } = {}
  card.sections.forEach(section => {
    if (section.type !== sectionTypes.CONTENT) return

    section.elements?.forEach(element => {
      if (element.kind === ElementKind.ASSESSMENT) {
        const assessment = element as AssessmentData

        data[assessment.id.toString()] = assessment.responses.filter(r => r.checked).map(r => r.id)
      }

      if (element.kind === ElementKind.QUESTION) {
        const question = element as QuestionData

        data[question.id.toString()] = question.value
      }
    })
  })

  return data
}

export default getDataFromActionCard
